// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ContentModal_spinner__IQCZz"};